import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isFeatureEnabled } from 'owa-feature-flags';
type ResourceMap = { [resourceUrl: string]: boolean };

// List of resources for which token can be fetched from MSAL.js
// Note: Partner services need to pre-authorize the new OWA app id before it can be enabled in this list.
let defaultResourceMap: ResourceMap = {
    'https://loki.delve.office.com/': true,
    'https://www.yammer.com/': true,
    'https://web.yammer.com/teams': true,
    'https://fe-26.qas.bing.net/compose': true,
    'https://api.diagnostics.office.com': true,
    'https://outlook.office365.com/connectors': true,
    'https://api.office.net': true,
    'https://clients.config.office.net/': true,
    'https://outlook.office.com/FocusedInboxB2': true,
    'https://outlook.office.com/search': true,
    'https://outlook.office365.com/search': true,
    'https://augloop.office.com/v2': true,
    'https://arc.msn.com/v4': true,
    'https://microsoft.sharepoint.com/': false,
    'https://microsoft.sharepoint.com': false,
    'https://microsoft.sharepoint-df.com/': false,
    'https://microsoft.sharepoint-df.com': false,
    'https://microsoft-my.sharepoint.com/': false,
    'https://microsoft-my.sharepoint.com': false,
    'https://microsoft-my.sharepoint-df.com/': false,
    'https://microsoft-my.sharepoint-df.com': false,
    'https://webdir.online.lync.com': true,
    'https://chatsvcagg.teams.microsoft.com': true,
    'https://teams.microsoft.com': true,
    'https://graph.microsoft.com': true,
    'https://graph.microsoft.com/': true,
    'https://pushchannel.1drv.ms': true,
    'https://outlook.office.com': true,
    'https://outlook-sdf.office.com': true,
    'https://outlook-sdf.office365.com': true,
    'https://outlook-sdf.office.com/': true,
    'https://outlook-sdf.office365.com/': true,
    'https://outlook.office.com/': true,
    'https://outlook.office365.com': true,
    'https://outlook.office365.com/': true,
    'https://outlook-sdf.live.com': false,
    'https://outlook.live.com': false,
    'https://cortana.ai': false,
    'https://dataservice.o365filtering.com': false,
};

export function isTokenFetchFromMsalEnabled(resourceUrl: string): boolean {
    return (
        isFeatureEnabled('auth-msaljs-fetchResourceToken') &&
        isHostAppFeatureEnabled('msalTokenFetch') &&
        defaultResourceMap[resourceUrl]
    );
}
